import styled from '@emotion/styled'
import { Modal } from 'src/components/modal'
import { InsightDownloadModalContent } from 'src/views/insight-download/modal/content'
import { InsightDownloadTopBar } from 'src/views/insight-download/modal/top-bar'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
`

type InsightDownloadModalProps = {
  open: boolean
  onClose: () => void
  title?: string
}
export const InsightDownloadModal = (props: InsightDownloadModalProps) => {
  const { open, onClose } = props

  const onModalClose = (_: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return
    }
    onClose()
  }
  return (
    <Modal
      open={open}
      onClose={onModalClose}
      style={{
        height: '90vh',
        width: '80vw',
        background: 'transparent',
      }}>
      <ModalContent>
        {/* Temp hide report preview when map builder is open (dont unmount) */}
        <div
          style={{
            height: '100%',
          }}>
          <InsightDownloadTopBar onClose={onClose} />
          <InsightDownloadModalContent />
        </div>
      </ModalContent>
    </Modal>
  )
}
